import styled from 'styled-components';
import { ButtonBorderRadius } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';

const HeaderContainer = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	background-color: rgba(255, 255, 255, 0.03);
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const Title = styled(Text)`
	font-size: 18px;
	font-weight: 600;
	color: #ffffff;
`;

const StyledCloseButton = styled.button<{ $hover?: boolean }>`
	position: absolute;
	top: 50%;
	right: 15px;
	transform: translateY(-50%);
	background-color: ${(props) => (props.$hover ? '#ffffff' : 'transparent')};
	border: none;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: ${ButtonBorderRadius.Radius10}px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&::before {
		content: '';
		position: absolute;
		width: 14px;
		height: 2px;
		background-color: ${(props) =>
			props.$hover ? '#000000' : 'rgba(255, 255, 255, 0.5)'};
		transform: rotate(45deg);
		transition: background-color 0.3s ease;
	}

	&::after {
		content: '';
		position: absolute;
		width: 14px;
		height: 2px;
		background-color: ${(props) =>
			props.$hover ? '#000000' : 'rgba(255, 255, 255, 0.5)'};
		transform: rotate(-45deg);
		transition: background-color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		&::before,
		&::after {
			background-color: #000000;
		}
	}
`;

export { HeaderContainer, StyledCloseButton, Title };
